export default __webpack_public_path__ + "static/media/CNo.73-2.6c494086.jpg";